import React from "react";

const ConfirmationModal = ({
  onConfirmation,
  onCancellation,
  title,
  confirmationLabel = "Confirm",
  cancellationLabel = "Cancel",
  description,
  open=false
}) => {

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-1002 overflow-y-auto flex items-center justify-center">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/50  transition-opacity"
        onClick={onCancellation}
      />
      {/* Modal */}
      <div className="relative bg-white dark:bg-gray-900 rounded-xl shadow-xl p-6 w-full max-w-md mx-4 z-10">
        <h2 className="text-lg font-semibold mb-2 text-gray-900 dark:text-white">
          {title}
        </h2>
        {description && (
          <p className="mb-4 text-gray-600 dark:text-gray-300">
            {description}
          </p>
        )}
        <div className="flex justify-end gap-2 mt-6">
          <button
            onClick={onCancellation}
            className="px-4 py-2 rounded-md bg-gray-200 hover:bg-gray-300 text-gray-800 dark:bg-gray-800 dark:text-gray-200 dark:hover:bg-gray-700 transition"
          >
            {cancellationLabel}
          </button>
          <button
            onClick={onConfirmation}
            className="px-4 py-2 rounded-md bg-primary text-white hover:bg-primary/90 transition"
          >
            {confirmationLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;